/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerBlockGroups.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Block Groups
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Thursday, September 27, 2018 - 07:28:04 PM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      09/27/2018  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    BLOCKGROUP_LIST_CONTAINER_LOADED,
    BLOCKGROUP_LIST_CONTAINER_UNLOADED,
    BLOCKGROUP_LIST_TABLE_LOADED,
    BLOCKGROUP_LIST_TABLE_UNLOADED,

    BLOCKGROUP_SELECT_ROW,
    BLOCKGROUP_ADD,
    BLOCKGROUP_EDIT,
    BLOCKGROUP_DELETE,
    BLOCKGROUP_OPEN_WARNING,
    BLOCKGROUP_CLOSE_WARNING,
    BLOCKGROUP_DELETE_DISABLE,

    BLOCKGROUP_EDIT_CONTAINER_LOADED,
    BLOCKGROUP_EDIT_CONTAINER_UNLOADED,
    BLOCKGROUP_EDIT_TABGROUPS_LOADED,
    BLOCKGROUP_EDIT_SET_TABGROUP_OPTIONS,
    BLOCKGROUP_EDIT_SET_TAB_OPTIONS,
    BLOCKGROUP_EDIT_FORM_LOADED,
    BLOCKGROUP_EDIT_FORM_UNLOADED,
    BLOCKGROUP_EDIT_DATA_LOAD,
    BLOCKGROUP_EDIT_CONTAINER_SUBMIT,
    BLOCKGROUP_EDIT_CONTAINER_CANCEL
} from '../constants/actionTypeBlockGroups';

const defaultState = {
    refreshList: false,
    danger: false,
    blockgroupid: 0,
    parentid: 0,
    name: '',
    description: '',
    jointable: '',
    primarykey: '',
    tabgroupid: 0,
    tabid: 0,
    orderid: 0,
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case BLOCKGROUP_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                blockgroups: action.payload[0] ? action.payload[0].records : null,
                itempath: action.payload[1] ? action.payload[1].records : []
            }
        case BLOCKGROUP_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case BLOCKGROUP_SELECT_ROW:
            return {
                ...state,
                blockgroupid: action.id
            }
        case BLOCKGROUP_ADD:
            return {
                ...state
            }
        case BLOCKGROUP_EDIT:
            return {
                ...state,
                blockgroupid: action.id
            }
        case BLOCKGROUP_DELETE:
            return {
                ...state,
                blockgroupid: null
            }
        case BLOCKGROUP_DELETE_DISABLE:
            return {
                ...state,
                disableDelete: action.disabled
            }
        case BLOCKGROUP_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case BLOCKGROUP_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case BLOCKGROUP_EDIT_CONTAINER_LOADED:
        case BLOCKGROUP_EDIT_DATA_LOAD:
            return {
                ...state,
                blockgroupid: action.payload[0] ? action.payload[0].blockgroupid : 0,
                parentid: action.payload[0] ? action.payload[0].parentid : 0,
                name: action.payload[0] ? action.payload[0].name : '',
                description: action.payload[0] ? action.payload[0].description : '',
                jointable: action.payload[0] ? action.payload[0].jointable : '',
                primarykey: action.payload[0] ? action.payload[0].primarykey : '',
                tabgroupid: action.payload[0] ? action.payload[0].tabgroupid : 0,
                tabid: action.payload[0] ? action.payload[0].tabid : 0,
                orderid: action.payload[0] ? action.payload[0].orderid : 0,
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : ''
            }
        case BLOCKGROUP_EDIT_TABGROUPS_LOADED:
            return {
                ...state,
                tabgroups: action.payload[0] ? action.payload[0].records : [],
                tabs: action.payload[1] ? action.payload[1].records : []
            }
        case BLOCKGROUP_EDIT_SET_TABGROUP_OPTIONS:
            return {
                ...state,
                tabGroupOptions: action.payload ? action.payload : []
            }
        case BLOCKGROUP_EDIT_SET_TAB_OPTIONS:
            return {
                ...state,
                tabOptions: action.payload ? action.payload : []
            }
        case BLOCKGROUP_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case BLOCKGROUP_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case BLOCKGROUP_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case BLOCKGROUP_LIST_CONTAINER_UNLOADED:
        case BLOCKGROUP_LIST_TABLE_UNLOADED:
        case BLOCKGROUP_EDIT_CONTAINER_UNLOADED:
        case BLOCKGROUP_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/reducerBlockGroups.js